import { render, staticRenderFns } from "./FileUploadAndPreviewPdf.vue?vue&type=template&id=5ff9f7d2&scoped=true"
import script from "./FileUploadAndPreviewPdf.vue?vue&type=script&lang=js"
export * from "./FileUploadAndPreviewPdf.vue?vue&type=script&lang=js"
import style0 from "./FileUploadAndPreviewPdf.vue?vue&type=style&index=0&id=5ff9f7d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff9f7d2",
  null
  
)

export default component.exports